import React from 'react'

import * as css from './ZoomImagenVencimiento.css'

/* Factor de aumento del zoom */
const FACTOR_ZOOM = 3

/* Componente exclusivo del modal de revisión de vencimientos (frontEnd/auditorias/revision/Modales.jsx).
 * Es una copia del componente ZoomImagen (frontEnd/components/ZoomImagen/ZoomImagen.jsx) para poder
 * modificarlo sin afectar a las otras vistas que utilizan el componente original.
 *
 * Diferencias con el componente original:
 *  - La imagen se limita al tamaño de la pantalla del usuario (nunca es más grande que el viewport).
 *  - El zoom es fijo de 3x y se realiza sobre la zona de la imagen por donde pasa el mouse. */
export class ZoomImagenVencimiento extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            zoomActivo: false,
            anchoImagen: 0,
            altoImagen: 0,
            origenX: 0,
            origenY: 0
        }
        this.mouseEnterImagen = (evt)=>{
            this.actualizarZoom(evt)
        }
        this.mouseMoveImagen = (evt)=>{
            if(this.state.zoomActivo){
                this.actualizarZoom(evt)
            }
        }
        this.mouseLeaveImagen = ()=>{
            this.setState({ zoomActivo: false })
        }
        //Guarda las medidas de la imagen (para el tamaño de la ventana de zoom) y la posición
        //de la imagen señalada por el mouse (para el origen del zoom)
        this.actualizarZoom = (evt)=>{
            const rect = evt.target.getBoundingClientRect()
            if(!rect.width || !rect.height){
                return
            }
            this.setState({
                zoomActivo: true,
                anchoImagen: rect.width,
                altoImagen: rect.height,
                origenX: this.acotar(evt.clientX - rect.left, rect.width),
                origenY: this.acotar(evt.clientY - rect.top, rect.height)
            })
        }
        //Limita un valor dentro del rango 0 - máximo
        this.acotar = (valor, maximo) => Math.round(Math.min(Math.max(valor, 0), maximo))
        //Centra en la ventana de zoom el punto de la imagen señalado por el mouse,
        //sin dejar espacios vacíos en los bordes de la ventana
        this.centrarZoom = (origenZoom, tamanoZoom, tamanoVentana) => {
            const centrado = (tamanoVentana / 2) - origenZoom
            const minimo = tamanoVentana - tamanoZoom
            return Math.round(Math.min(0, Math.max(minimo, centrado)))
        }
    }
    //Al cambiar la foto (elaboración / duración) se oculta el zoom para recalcular las medidas
    componentWillReceiveProps(nextProps) {
        if(nextProps.ruta_imagen !== this.props.ruta_imagen){
            this.setState({ zoomActivo: false })
        }
    }
    render() {
        const zoom = this.state
        const anchoZoom = zoom.anchoImagen * FACTOR_ZOOM
        const altoZoom = zoom.altoImagen * FACTOR_ZOOM
        return (
            <div className={css.contenedor}>
                <img
                    src={`${this.props.ruta_imagen}`}
                    className={css.imagenOriginal}
                    onMouseEnter={this.mouseEnterImagen}
                    onMouseMove={this.mouseMoveImagen}
                    onMouseLeave={this.mouseLeaveImagen}
                />
                {
                    zoom.zoomActivo ?
                        <div className={css.ventanaZoom} style={{width: zoom.anchoImagen, height: zoom.altoImagen}}>
                            <img
                                src={`${this.props.ruta_imagen}`}
                                className={css.imagenZoom}
                                style={{
                                    width: anchoZoom,
                                    height: altoZoom,
                                    left: this.centrarZoom(zoom.origenX * FACTOR_ZOOM, anchoZoom, zoom.anchoImagen),
                                    top: this.centrarZoom(zoom.origenY * FACTOR_ZOOM, altoZoom, zoom.altoImagen)
                                }}
                            />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/ZoomImagenVencimiento.jsx